import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["CONTACT_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["CONTACT_MODULE"],
  },
];

export default routes;
